import { config, event } from 'vue-gtag'

const sendLogin = (code) => {
  event('login', {
    user_id: code
  })
  setUser(code)
}

const setUser = (code) => {
  config({
    user_id: code
  })
}

export default {
  sendLogin,
  setUser
}
